import { isNud } from '@/shared/utilities/typing'
import AccountUser from '@/shared/models/entities/account-user';

/**
 * ホシツキ小テスト エンティティ
 */
class Quiz {
    account_user;
    is_submitted;
    answer_1;
    answer_2;
    answer_3;
    answer_4;
    answer_5;
    answer_6;
    answer_7;
    answer_8;
    answer_9;
    answer_10;

    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }

        this.account_user = new AccountUser(properties.account_user);
        this.is_submitted = properties.is_submitted ?? 0;
        this.answer_1 = properties.answer_1;
        this.answer_2 = properties.answer_2;
        this.answer_3 = properties.answer_3;
        this.answer_4 = properties.answer_4;
        this.answer_5 = properties.answer_5;
        this.answer_6 = properties.answer_6;
        this.answer_7 = properties.answer_7;
        this.answer_8 = properties.answer_8;
        this.answer_9 = properties.answer_9;
        this.answer_10 = properties.answer_10;
    }
}

export default Quiz;
